/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { assert } from "@ember/debug";
import Component from "@glimmer/component";
import { modifier } from "ember-modifier";
/**
 * A component with a label and radio buttons.
 * Label and buttons are displayed as block, radio buttons are inlined.
 */
export default class AlignedFieldsRadioGroupComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "ensureFieldParent", modifier(function (element) {
      assert(`The component 'aligned-fields-radio-group-component' must be a direct child of a 'field' element in the DOM`, element.parentElement.classList.contains("field"));
    }));
  }
}